import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import { commandBarKeycapSx } from './commandBar.styles'

type CommandBarKeycapProps = {
  label: string
}

export const CommandBarKeycap = ({ label }: CommandBarKeycapProps) => (
  <Box component="span" sx={commandBarKeycapSx}>
    {label}
  </Box>
)

/** « ⌘⇧P » ou « Ctrl+Shift+P » devient une pastille par touche. */
export const splitShortcutKeys = (shortcut: string) => {
  if (shortcut.includes('+')) return shortcut.split('+').map((key) => key.trim()).filter(Boolean)
  if (shortcut.startsWith('⌘⇧')) return ['⌘', '⇧', shortcut.slice(2)]
  if (shortcut.startsWith('⌘')) return ['⌘', shortcut.slice(1)]
  if (shortcut.startsWith('⌥') && shortcut.length > 1)
    return ['⌥', shortcut.slice(1)]
  return [shortcut]
}

export const ShortcutKeycaps = ({ shortcut }: { shortcut: string }) => (
  <Stack direction="row" spacing={0.25} component="span">
    {splitShortcutKeys(shortcut).map((key, index) => (
      <CommandBarKeycap key={`${key}-${index}`} label={key} />
    ))}
  </Stack>
)
